import React from 'react';
import { Route as RouteDOM, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ROUTES from './constants';

import { useAuth } from '../services';

const Route = ({ isPrivate, component: Component, ...props }) => {
  const { isLogged } = useAuth();

  return (
    <RouteDOM
      {...props}
      render={({ location }) => {
        if (isPrivate === isLogged) {
          return <Component />;
        }
        return (
          <Redirect
            to={{
              pathname: isPrivate
                ? ROUTES.BACKOFFICE.LOGIN
                : ROUTES.BACKOFFICE.HOME,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

Route.defaultProps = {
  isPrivate: false,
};

Route.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

export default Route;
